import React, { useState } from 'react';
import ViolationIssueCommentItem from './ViolationIssueCommentItem';
import { Row, Col, FormControl, Button } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup'
import IssueService from '../../../services/Shared/issues.service';

function ViolationIssueComment({ comments, issueClosed, issueId, type, isUserEditable }) {
    const [issueComments, updateIssueComments] = useState(comments);
    const [commentBox, updateCommentBox] = useState("");
    const commentsMarkup = issueComments.map((item, i) => {
        return <Row key={i}><Col><ViolationIssueCommentItem person={item.formattedName} commentDate={new Date(item.dateCrte).toLocaleString()} comment={item.text} /></Col></Row>
    })
    const commentAdd = () => {
        if (commentBox) {
            IssueService.postIssueComment(issueId, commentBox, type).then((response) => {
                if (response.data) {
                    updateIssueComments([...issueComments, response.data]);
                    updateCommentBox("");
                }
            });
        }
    }

    return (
        <div className="issuesCommentSection">
            <Row><Col><h5>Messages</h5></Col></Row>
            <hr />
            {commentsMarkup}
            <Row>
                <Col>
                    <InputGroup className="mb-3">
                        <FormControl
                            placeholder="Add Comment"
                            aria-label="Add Comment"
                            value={commentBox}
                            onChange={e => updateCommentBox(e.target.value)}
                            onKeyPress={event => {
                                if (event.key === "Enter") {
                                    commentAdd();
                                }
                            }}
                            disabled={(issueClosed || !isUserEditable) ? "disabled" : ""}
                        />
                        <Button variant="outline-secondary" onClick={commentAdd} disabled={(issueClosed || !isUserEditable) ? "disabled" : ""}>Submit</Button>
                    </InputGroup>
                </Col>
            </Row>
        </div>
    )
}

export default ViolationIssueComment;